// EmailJS 설정
// 무료 계정으로 매달 200개 이메일 전송 가능
// 설정 방법:
// 1. https://www.emailjs.com/ 가입
// 2. Email Service 추가 (Gmail 등)
// 3. Email Template 생성
// 4. 아래 값들을 실제 값으로 교체

export const EMAIL_CONFIG = {
  SERVICE_ID: "service_fplh9qs",  // EmailJS Service ID
  TEMPLATE_ID: "template_1lcqsxw", // EmailJS Template ID
  PUBLIC_KEY: "YQU6SwYpxWfOfOFHN"  // EmailJS Public Key
};

// 이메일 템플릿 예시 (EmailJS 대시보드에서 설정)
/*
Template Name: error_notification
Subject: [랜딩페이지 에러] 고객 데이터 저장 실패 - {{name}}

Content:
랜딩페이지에서 고객 데이터 저장 중 오류가 발생했습니다.

고객 정보:
- 이름: {{name}}
- 전화번호: {{phoneNumber}}
- URL 코드: {{urlCode}}
- 신청 시간: {{date}}

에러 정보:
- 에러 타입: {{errorType}}
- 에러 메시지: {{errorMessage}}

즉시 확인이 필요합니다.
*/